module.exports = __webpack_public_path__ + "img/IVillager64_ua.d6f3a057.webp";